<button [ngClass]="[(enabled ? 'button-check' : 'button-check-disabled'), customSpinnerButton]" type="submit" [disabled]="!enabled">
    <i class="spinner" *ngIf="running">       
    </i>{{label}}
</button>